  // Accordion

const singleAccordion = document.querySelector('.single')  
const multipleAccordion = document.querySelector('.multiple')  

const accordions = document.querySelectorAll(".custom-accordion");
const accordionParent = document.querySelectorAll('.accordion_items');


      const openAccordion = (accordion) => {
        const content = accordion.querySelector(".accordion__content");
        const angle = accordion.querySelector(".angle");
        accordion.classList.add("accordion__active");
        content.style.maxHeight = content.scrollHeight + "px";
        angle.style.transform = "rotate(180deg)";
      };

      const closeAccordion = (accordion) => {
        const content = accordion.querySelector(".accordion__content");
        const angle = accordion.querySelector(".angle");
        accordion.classList.remove("accordion__active");
        content.style.maxHeight = null;
        angle.style.transform = "rotate(0deg)";
      };

     // Main Init Function
const initAccordions = () => {
  // Check if page has single or multiple mode
  const singleAccordion = document.querySelector(".single");
  const multipleAccordion = document.querySelector(".multiple");

  // Single Mode: All accordions behave as one group
  if (singleAccordion) {
    const accordions = singleAccordion.querySelectorAll(".custom-accordion");
    accordions.forEach((accordion) => {
      const intro = accordion.querySelector(".accordion-heading");
      const content = accordion.querySelector(".accordion__content");

      intro.onclick = () => {
        if (content.style.maxHeight) {
          closeAccordion(accordion);
        } else {
          accordions.forEach((acc) => closeAccordion(acc));
          openAccordion(accordion);
        }
      };
    });
  }

  // Multiple Mode: Each .accordion_items works independently
  if (multipleAccordion) {
    const accordionGroups = multipleAccordion.querySelectorAll(".accordion_items");

    accordionGroups.forEach((group) => {
      const accordions = group.querySelectorAll(".custom-accordion");

      accordions.forEach((accordion) => {
        const intro = accordion.querySelector(".accordion-heading");
        const content = accordion.querySelector(".accordion__content");

        intro.onclick = () => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            // close only within this group
            accordions.forEach((acc) => closeAccordion(acc));
            openAccordion(accordion);
          }
        };
      });
    });
  }
};

// Init on DOM load
document.addEventListener("DOMContentLoaded", initAccordions);


 
